/**
 * @Page GNGS
 * @Description [GNGS]기능개선 요청/제안
 **/
import React, { useState, useEffect, useRef, useCallback  } from "react";
import { Link , useParams} from 'react-router-dom';
import Ribbon from '@/components/organisms/Ribbon';
import ContentXearch from '@/components/organisms/ContentXearch';
import Content from '@/components/organisms/Content';
import Grid from '@/components/grid/agGrid';
import * as GridUtil from '@/components/grid/agGrid';
import CustomAlert from "@/components/molecules/CustomAlert";
import AlertDialog from '@/components/material-UI/AlertDialog';
import * as Common from '@/utils/Common'; 
import CommonUtil from '@/utils/CommonUtil'; // Util.js
import Popup from '@/pages/Popup/Popup';     


const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER; 
const CODES = require('@/config/commonCode.json');
const gbn = [{ "comCode" : "****",  "text": "공통" }];  //조회조건 구분 
const Utils = new CommonUtil();

function GNGS({onClose}) {
    const token = Common.getToken();
    const userId = Common.getToken("id");
    const userName = Common.getToken("name");
    const tVnt1 = Common.getToken("vand");
    const tComp = Common.getToken("comp");
    const bigi = Common.getToken("bigi");
    const gridGngsMain = useRef();   //Grid Main
    const {id} = useParams();


    //Data
    const [idata, setData] = useState({
        //조회조건
        kSear : "1",      
        kSval : "",
        kGubn : "",
        vdnm:"",
        numb:"",
        userName:userName,
    }); 

   
    const [message, setMessage] = React.useState( {
        openAlert : false,      
        severity : "success",   
        msg : ""                
    });
    const { openAlert, severity, msg } = message;
    const [typeOpen, setTypeOpen] = React.useState(false);
    const [typeOpen2, setTypeOpen2] = React.useState(false);
    const [data, setDatas] = useState([]);
    //Dialog
    const [dlgMessage, setDlgMessage] = React.useState( {
        openDlg : false,    
        dlgTrans : "",      
        dlgMsg : ""         
    });
    const { openDlg, dlgTrans, dlgMsg } = dlgMessage;


    //Grid Search, Insert, Update, Delete Api
    let [searchApi, setSearchApi] = useState(false); 
    let [insertApi, setInsertApi] = useState(false); 
    let [updateApi, setUpdateApi] = useState(false); 
    let [deleteApi, setDeleteApi] = useState(false); // deleteApi 항목 setting
    const [panded, setPanded] = React.useState(true);
    const [style, setStyle] = useState({ height :"calc(100vh - 65px - 35px - 50px - 21px - 56px - 8px )"});

    const onClearApi = useCallback(async (e) => {
        setSearchApi(false);
        setInsertApi(false);
        setUpdateApi(false);
        setDeleteApi(false);
    }, []);
    
    

    /**
     * 공통코드 조회
     */
    const onSearchCommon = (para) => {

      
    }



    /**
     *MOUNT 
     */
    useEffect( () => {
    
        //공통코드 조회
        onSearchCommon(`{"pgmid":"CODE", "vand":"****", "gocd" : "00"}`);
        
        if(id) {
            let data = [];
            data["open"] = typeOpen;
            data["setopen"] = setTypeOpen;
            data["gubnView"] = "search";
            data["numb"]=id;
            setTypeOpen(true);
            setDatas({...data});
            //setDatas(()=>{return data });
        }else{
            onSearch()
        }
    }, []);


    /**
     * Control 변경 Event
     * @param {*} e 
     */
    const onChange = async (e) => {
        const { name, value } = e.target;

        let newSearchs = idata;
        newSearchs[name] = value

        setData({ ...newSearchs });

    }

    const onRowClicked = async (e) => {
        let data =  e.data;        
        data["open"] = typeOpen;
        data["setopen"] = setTypeOpen;

        setDatas({ ...data });

        setTypeOpen(true);
    }


    /**
     * 검색조건
     */
     const optionsX = {
        0: [
            //구분
            {
                formatter: "radio", name: "kSear", labelName: "", type: "text", desc: "", readOnly: false,
                options: [{name: "kSear1", setValue: "1", labelName: "제목"}, {name: "kSear2", setValue: "2", labelName: "글쓴이"}, {name: "kSear3", setValue: "3", labelName: "날짜"}],
                defaultValue: idata.kSear,  
                align: "left", 
                labelType: "none", 
            }, 
            //그룹코드
            {
                formatter: "input", name: "kSval", labelName: "", type: "text", desc: "",
                defaultValue: idata.kSval,  
                align: "left", 
                labelType: "none" 
            }, 
            {"formatter": "blank", "align": "left" },
            {"formatter": "blank", "align": "left" },
            {"formatter": "blank", "align": "left" },
            {"formatter": "blank", "align": "left" }
        ]
    }



    /**
     * 조회 
     * @param {*} e 
     * @returns 
     */
    const onSearch = async (e) => {
       
        let para = `{"kSear":"${idata.kSear}","kSval":"${idata.kSval}"}`;
        let param = encodeURI(para);

        const query = SERVER_URL + "/wrtgngs/search?query=" + param;
        setSearchApi(query); // Search API
    }



    /**
     * 신규 Row추가
     * @param {*} e 
     */
    const onAddRow = async (e) => {
    }


    
    /**
     * 입력
     * @param {*} e 
     */
    const onInsert = async (e) => {
        let data =  [];

        data["userId"] = idata.userId;  //아이디
        data["vdnm"] = idata.userName;  //이름
        data["gubn"] = "N";  //업체만보기 구분
        data["gubnView"] = "insert";
        data["chk"] = 0;    //최초 입력인지 확인
        data["titl"] = "";  //제목
        
        setDatas({ ...data });
        // setDatas(data);
        setTypeOpen2(true);
    }



    /**
     * 수정 
     * @param {*} e 
     * @returns 
     */
    const onUpdate = async (e) => {

         //input check
         let input = await Promise.all ([inputCheck('U')]);
         if ( !input[0]) return;
        
        const query = SERVER_URL + "/rsy10/update";
        setUpdateApi(query); // Update API
    }



    /**
     * 삭제
     * @param {*} e 
     */
    const onDelete = async (e) => {
         
       
    }



    // input check
    const inputCheck = (gbn) => { 

        
    }



    //Transaction AlertDialogResult
    const AlertDialogResult = async (e) => {

        //AlertDialog 초기화
        setDlgMessage({ openDlg : false,  dlgTrans : "", dlgMsg : ""});

        //DialogResult
        if (e.result == "N") return;

        //Transaction 구분
        switch (e.Trans) 
        {
            //등록
            case "I" :
                break;
            //수정
            case "U" :
                break;
            //삭제
            case "D" :
                break;
        }
    }

    const gbgnFormatter = (params) => {
        if(params.value == "1"){
            return "기능개선"
        }
        else if(params.value == "2"){
            return "신규기능"
        }
        else if(params.value == "3"){
            return "아이디어"
        }
        else if(params.value == "4"){
            return "기타"
        }
        else{
            return ""
        }        
      };
    


    /**
     *Grid Column 정의 
     */
    const columnDefs = [
        { headerName: "iusa", field: "iusa", sortable: true, filter: true, flex: 1, minWidth: 50, hide: true,  cellClass: ["nocheckbox", "alignC"] }, 
        { headerName: "pseq", field: "pseq", sortable: true, filter: true, flex: 1, minWidth: 50, hide: true,  cellClass: ["nocheckbox", "alignC"] }, 
        { headerName: "No", field: "numb", sortable: true, filter: true, flex: 1, minWidth: 50, hide: false,  cellClass: ["nocheckbox", "alignC"] }, 
        { headerName: "구분", field: "gngb", sortable: true, filter: true, flex: 1, minWidth: 80, editable: false,  cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false, valueFormatter : gbgnFormatter }, 
        { headerName: "제 목", field: "titl", sortable: true, filter: true, flex: 1, minWidth: 800, hide: false,  cellClass: ["nocheckbox", "alignL"] ,
        cellStyle: params=> {
            return {'white-space':'pre'} // 공백 띄어쓰기 표출
        }, cellRendererFramework: GridUtil.AgGridReply /* Re: 답글 표출 기능 */},
        // }},                
        { headerName: "업체명", field: "vdnm", sortable: true, filter: true, flex: 1, minWidth: 80, editable: false,  cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false },  //valueFormatter : Utils.numberFormatter        
        { headerName: "글쓴이", field: "usnm", sortable: true, filter: true, flex: 1, minWidth: 80, editable: false,  cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false },         
        { headerName: "업체만 보기", field: "gubn", sortable: true, filter: true, flex: 1, minWidth: 80, editable: false,  cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: true }, 
        { headerName: "날짜", field: "idat", sortable: true, filter: true, flex: 1, minWidth: 80, editable: false,  cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false,valueFormatter: Utils.dateFormatter }, 
        { headerName: "조회수", field: "rcnt", sortable: true, filter: true, flex: 1, minWidth: 80, editable: false, cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false,valueFormatter: Utils.numberFormatter }, 
    ];

    const onClick = async (e) => {
        setPanded(!panded);

        if(panded===true){
            setStyle({       
                height :"calc(100vh - 65px - 35px - 50px - 21px - 8px)"
              });
        }else{
            setStyle({
                height :"calc(100vh - 65px - 35px - 50px - 21px - 56px - 8px)"
              });
        }
    }
    
    return(
        <>
            {/* Dialog FRAME */}
            <AlertDialog open={openDlg}  trans={dlgTrans} message={dlgMsg} onClose={AlertDialogResult} />

            {/* Alert FRAME */}
            <CustomAlert open={openAlert} severity={severity} duration={3000} message={msg} onClose={()=> {setMessage({openAlert:false, severity:"", msg:"조회 실패"})}} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} />
            <Popup type="GngsPopup" open={typeOpen} onClose={()=> {setTypeOpen(false);onSearch();}} data={data}/>
            <Popup type="GngsWrite" open={typeOpen2} onClose={()=> {setTypeOpen2(false);onSearch();}} data={data}/>
                    
            {/* Ribbon Frame : 프로그램 Path 및 버튼 */}
            <Ribbon
                onInfoMsg={"랩도스 서비스의 기능개선 요청 및 제안하고자 하시는 사항을 등록하는 화면입니다."}
                onInfoManual={false}                        // onInfoManual : 매뉴얼 표출 버튼 무조건 사용 // false : 사용안함 (popup 의경우 false 셋팅)
                onSearch={onSearch} onSearchName={null} //조회
                onInsert={onInsert} onInsertName={null} //onInsertVisible = {tVnt1 === "M000"}    //등록
                // onUpdate={onUpdate} onUpdateName={null} onUpdateVisible = {tVnt1 === "M000"}   //수정
                // onDelete={onDelete} onDeleteName={null} onDeleteVisible = {tVnt1 === "M000"}    //삭제
            >
                <b style={{ color: "#cd5c5c", fontFamily: "PretendardLight, NanumGothic, sans-serif" }}>기능개선 요청/제안</b>
            </Ribbon>


            {/* ContentXearch Frame : 검색조건 */}
            <ContentXearch
                optionsX={optionsX}
                onChange={onChange}
                onClick={onClick} />


            {/* Content FRAME (Data / Grid Frame) START -------------- */}
            <Content style={style}> {/* Content 항목에서의 100%에서 Header:60px,  Ribbon:50px,  검색조건:55px */}
                <div className={"grid_type01"} > {/* 상단 FRAME */}
                    <div className={"grid_wrap01"}> {/* 상단 wrap FRAME */}
                        <div className="grid_cont_box" style={{ height: "calc(100%)" }}>
                            <Grid
                                ref={gridGngsMain}
                                gridId={"QNA"}                    //  (필수) Grid Id 정의
                                columnDefs={columnDefs}             //  (필수) 컬럼 정의 
                                pagination={false}                  //  쪽수 매기기 여부
                                paginationCsv={true}                //  CSV 사용구분 - pagination과 동시에 사용 필요
                                paginationPageSize={"1000"}         //  쪽수 1Page 당 Row수
                                rowMultiSelectWithClick={true}      //  멀티 클릭 가능 여부
                                suppressRowClickSelection={true}    //  클릭으로 선택 하는것을 방지
                                rowSelection={"single"}           //  여러개 선택 "multiple" 가능, 한개 선택할 때는 "single"
                                enableRangeSelection={false}        //  
                                enableCellTextSelection={false}      // cell selection drag mode
                                isFirst={false}                      // 첫번째 컬럼 체크박스 사용여부 - ( default 체크박스 사용안함 )
                                displayNo = {false}
                                searchApi={searchApi}               // 조회
                                insertApi={insertApi}               // 등록
                                updateApi={updateApi}               // 수정
                                deleteApi={deleteApi}               // 삭제
                                //updateRefresh={onSearch}          // 수정이후 
                                deleteRefresh={onSearch}            // 삭제이후 
                                onClearApi={onClearApi}
                                //onClearApi={()=> {setSearchApi(false); setUpdateApi(false);}}
                                // onCellValueChangedEvent={onCellValueChanged}
                                onRowClickEvent={onRowClicked}
                            />
                        </div>
                    </div>
                </div>
            </Content>
        </>
    )
}
export default GNGS;